import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useGeneralStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontFamily: 'Roboto',
      fontSize: '10pt',
      backgroundColor: 'white',
      color: theme.palette.grey['600'],

      boxShadow: '0px 0px 5px 0px grey',
      padding: '10.164mm',
      textAlign: 'left',
      width: '210mm',
      boxSizing: 'border-box',

      '@media print': {
        boxShadow: 'none',
        padding: 0,
        width: '100%',
      },
      '& h1, & h2, & h3': { pageBreakInside: 'avoid' },
    },
    empty: {
      boxShadow: 'none !important'
    }
  }),
);

export default useGeneralStyles;
